import { PropsWithChildren } from 'react';
import { Box, styled } from '@mui/material';
import { LoadingScreen } from '@nohara-dxdev/react-core';

import { Navbar } from './navbar';

import NotFoundRoute from '@/app/routes/not-found';
import { AppAssignmentCheck } from '@/features/apps/components/app-assignment-check';

const LayoutContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
}));

const MainContent = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  [theme.breakpoints.down('md')]: {
    padding: '0px 10px',
  },
}));

const ContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.background.default,
  minHeight: 'calc(100vh - 64px)', // Subtract navbar height
  [theme.breakpoints.down('sm')]: {
    minHeight: 'calc(100vh - 56px)', // Smaller navbar height on mobile
  },
}));

export const AppLayout = ({ children }: PropsWithChildren) => {
  return (
    <AppAssignmentCheck loadingElement={<LoadingScreen />} fallbackElement={<NotFoundRoute />}>
      <LayoutContainer>
        <Navbar />
        <MainContent>
          <ContentArea>{children}</ContentArea>
        </MainContent>
      </LayoutContainer>
    </AppAssignmentCheck>
  );
};
